import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h4
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "blue",
          }}
        >
          {" "}
          <b>Circular Economy Potential of Microalgal Refinery</b>
        </h4>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Renewable energy resources are intrinsically linked to social,
              economic, and envi- ronmental dimensions and need to be
              economically viable, technically feasible, socially acceptable,
              and environmentally sound to achieve sustainability (Chat- terjee
              &amp; Rayudu, 2018). Industrialization and subsequent
              globalization witnessed an escalation in energy utilization,
              evident from the increase in the average per capita electricity
              consumption from 2.5 MJ d<sup>&minus;1</sup> to more than 200 MJ d
              <sup>&minus;1</sup> (Ramachandra &amp; Hegde, 2015). Next to
              electricity, the major energy required is the conventional non-
              renewable fuels such as refined petroleum products and natural gas
              for mobility in the transportation sector. The global primary
              energy consumption is about 25,912 quadrillion Btu in petroleum
              (in 2019). The biomass and natural gas contribution was about 1411
              and 978 quadrillion Btu. However, the fast-perishing stock of
              fossil resources with the escalating greenhouse gas (GHG)
              footprint necessitates the inves- tigation of sustainable
              alternatives to meet the ever-increasing demand for energy in the
              transportation sector. The transition to biofuels gives the
              additional benefits of decarbonization, decentralized employment
              generation (and remediation, in the case of feedstock cultivation
              in wastewater), and the scope for economic viability through a
              circular economy in the algal refinery. Decarbonization aids in
              mitigating global warming and changes in the climate (Jaccard,
              2006). Currently, there are numerous biofuel initiatives across
              the globe to reduce the reliance on petroleum&nbsp;fuel (Vlysidis
              et al., 2011) through decentralized local resources such as
              microalgae, etc. Biodiesel is one of the most promising biofuels
              shown to give engine performance with reduced particulate, carbon
              monoxide, and hydrocarbon emissions compared to conventional
              diesel (Graboski &amp; McCormick, 1998). Biodiesel has been
              produced from triglycerides derived from terrestrial oil seeds,
              animal fats, or algae. Biodiesel production from vegetable oils
              has been increasing during the past decade. However, the amount of
              oil produced in a hectare area from terrestrial oil seeds is
              limited. In this context, microalgae-derived oil has received
              significant attention due to its non- conflicting nature of fuel
              in terms of arable land availability or food (Ribeiro et al.,
              2015).
            </p>
            <p>
              Microalgae rich in carbohydrates, phycobilin, vitamins, proteins,
              pigments, antioxidants, bioactive compounds, and essential fatty
              acids offer vast potential for commercial exploitation. The
              biochemical composition of microalgae and biodiesel feedstock
              widens the scope for other bioenergy and value-added product
              production (Guldhe et al., 2017). There has been renewed interest
              in utilizing algae in various sectors, including pharmaceuticals,
              food, and animal feed. The main advantages of using microalgae
              are: (i) the most promising non-food feedstock for biofuel produc-
              tion; (ii) does not require arable lands with the ability to grow
              in degraded lands including saline waters/wastewaters; (iii)
              ability for an efficient fixation of CO<sub>2</sub>;
            </p>
            <p>
              (iv) remediation of wastewater with the uptake of nutrients for
              growth; (v) algae possess the capacity to produce lipids that are
              300&ndash;400 times higher than terres- trial feedstocks; (vi)
              carbon sequestration potential of biomass; (vii) diverse mix of
              energy and value-added bioproducts; (viii) livestock feed as a
              source of protein etc.; (ix) algal biofuel is non-toxic with no
              sulphur content and is exceptionally biodegradable. Remediation of
              wastewater through microalgal growth is gaining momentum as an
              economical and environmentally friendly option for wastewater
              treatment with biofuel production (Clarens et al., 2010). Hence,
              microalgae-based biofuel is emerging as an essential alternate
              resource to fossil fuels. However, signif- icant challenges in
              microalgal biofuels are higher energy demand during (i) cultiva-
              tion (upstream) and harvesting, (ii) drying, and (iii) biofuel
              production (downstream). Thus, employing efficient microalgae
              cultivation considering appropriate substrate (with biofilm
              inoculum) would render both cultivation and harvesting less expen-
              sive to accomplish the economic viability of microalgal biofuel.
              The exploitation of different microalgal components as a whole or
              in parts as co-exploitable products and minimizing waste
              production would enhance the economic viability with the potential
              of a circular economy. Optimal growth conditions would enhance
              hyper- accumulation of different bioproducts as a function of
              nitrogen concentration during different growth stages (Gifuni et
              al., 2019), as during exponential growth phase, proteins,
              chlorophylls and phycobiliproteins are accumulated, followed by
              accumu- lation of starch (during late exponential phase), PUFAs,
              TAGs, and UV protective pigments like carotenoids/astaxanthin are
              secreted during the stationary growth phase (triggered with
              nitrogen depletion). Thus, microalgae produce a plethora of
              products that find application in diverse industrial sectors (Chew
              et al., 2017).
            </p>
            <p>&nbsp;</p>
            <h4>2 Circular Economy Through the Microalgal Refinery</h4>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              The raw material (e.g., crude petroleum) undergoes a series of
              production processes with a potential output of diverse energy
              sources (gasoline, diesel, LPG, and ethanol) and an array of
              complex and valuable chemicals (volatile acids, fine chemicals,
              detergents, pharmaceuticals, waxes, and asphalt) in the
              conventional refinery. Simi- larly, biorefineries permit renewable
              raw materials utilization widely at low costs to produce
              high-value products with inherent energy potential (Laurens et
              al., 2017). The biorefinery concept integrates the production of
              various products, and cumula- tive benefits prove microalgal
              biofuel generation sustainable by providing economic viability.
              Figure 1 depicts the biorefinery using aquaculture wastewater for
              diverse bioproduct production with an added advantage of
              wastewater remediation.
            </p>
            <p>
              The biorefinery process involves valorizing microalgal biomass
              into a broad spectrum of value-added products and diverse energy
              forms (Linares et al., 2017). Microalgal biorefineries through
              efficient biomass processing would provide energy, polymers, food
              additives, nutraceuticals, bioactive compounds, co-products, etc.
              Processing biomass at multiple stages by targeting both primary
              and secondary prod- ucts of commercial interest would enhance the
              environmental and economic benefits (Hemalatha et al., 2019)
              compared to product valorization.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce1.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 1 </strong>Integrated microalgal cultivation system
              for biodiesel with bioproducts
            </p>
            <p>&nbsp;</p>
            <h5>2.1&nbsp; Primary Products from Microalgae</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              The macromolecular composition of microalgae includes (i) ash
              (5&ndash;17%); (ii) carbo- hydrates (18&ndash;46%); (iii) crude
              protein (18&ndash;46%); (iv) lipids (12&ndash;48%); and (v) energy
              (19&ndash;27 MJ/kg) (Tibbetts et al., 2015). Microalgae accumulate
              carbohy- drates in complex forms (such as cellulose, and starch.)
              apart from other exocellular polysaccharides (EPS). EPS is gaining
              considerable attention as hygroscopic agents (in cosmetic
              industries), topical agents, and antioxidants (Dragone et al.,
              2011). EPS is useful as natural auto-flocculating agents (Marella
              et al., 2020), surfactants, emulsifiers, anti-tumour, anti-viral,
              anti-coagulant, and anti-inflammatory agents (Venkata Mohan et
              al., 2020). Other primary products exploitable from microalgae are
              pigments (chlorophyll and carotenoids such as fucoxanthin and
              astaxanthin), amino acids (such as alanine linoleic acid and
              nucleic acid), etc. Phycobilipro- teins are rich sources of
              vitamin B1 (Mobin &amp; Alam, 2017). Microalgae possess different
              carotenoids such as beta carotene, lutein, lycopene, astaxanthin,
              zeax- anthin, fucoxanthin, and neoxanthin diadinoxanthin,
              canthaxanthin, violaxanthin (Mulders et al., 2014). Carotenoid
              finds its application in diverse domains of human health care,
              pharmaceuticals, nutraceuticals, and food processing (Sathasivam
              et al., 2019). Microalgae also aid as substitutes for fish oil,
              especially omega-3, Docosa- hexaenoic acid (DHA), Eicosapentaenoic
              acid (EPA), omega-6, and arachidonic acid (ARA) (Marella &amp;
              Tiwari, 2020). A range of primary products that are possible from
              model pennate diatom <em>Phaeodactylum tricornutum </em>as
              reported in (Butler et al., 2020) are: EPA, DHA, ARA,
              Triacylglycerol (TAG), and Brassicosterol that forms the major
              components of lipids, and Chrysolaminarin forms the major portion
              of carbohydrates. Fucoxanthin, Lupeol, and betulin from the major
              terpenoids class in the model diatom <em>P. tricornutum</em>. A
              marine microalga, <em>Nannochloropsis oceanica</em>, is targeted
              as a source of EPA and violaxanthin. <em>Synechocystis </em>sp.
              and <em>Arthrospira </em>sp. belong to cyanobacteria used to
              extract phycocyanin, terpenoids, and polyhy- droxy butyrate (PHB)
              (Mobin &amp; Alam, 2017). Microalgae are valuable sources of
              vitamins like A, B1, E, C, B6, B12, riboflavin, nicotinic acid,
              biotin, folic acid, and pantothenate (Chittora et al., 2020).
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h5>2.2&nbsp; Microalgae as Biofertilizers and Functional Foods</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Ensuring food security to the burgeoning population in developing
              economies has been a significant challenge. Green practices are
              gaining attention with the adoption of eco-friendly technologies
              to sustain food production while reducing the risk of
              chemical-based fertilizers (Andrade, 2018). Cyanobacteria are
              emerging as low-cost and eco-friendly biofertilizers. They help
              control the nitrogen deficiency in plants and are known to improve
              water holding capacity, enhance aeration of the soil, and act as
              reservoirs of vitamin B12 (Hall et al., 1995). The efficient
              nitrogen-fixing bacteria are <em>Anabaena variabilis</em>,{" "}
              <em>Nostoc linkia</em>, <em>Calothrix </em>sp.,{" "}
              <em>Tolypothrix </em>sp., <em>Spir- ulina platensis </em>(Chittora
              et al., 2020), which are useful as <em>N</em>, <em>P</em>, and{" "}
              <em>K </em>supplements for biofortification of soil (Anitha et
              al., 2016). Earlier studies show <em>Spirulina</em>,{" "}
              <em>Chlorella </em>sp., and <em>Palmaria palmata </em>helps in
              bio-augmentation NO<sub>3</sub>
              <sup>&minus;</sup>N and NH<sub>4</sub>
              <sup>+</sup>N during its field application (Alobwede et al.,
              2019). Microalgae, primarily diatoms, are being used widely as
              feeds and high-quality nutritional supplements for bivalves,
              juvenile fishes and shrimp larvae, and post-larvae (Marella et
              al., 2020; Shah et al., 2018). Diatoms also produce vitamins and
              proteins beneficial for aquaculture growth with proven
              antibacterial and anti-viral properties against pathogens
              proliferating in aqua- culture ponds. Table 1 lists the research
              institutions across the globe that are working on industrially
              relevant products from microalgae (diatoms) with details of
              targeted biomolecules.
            </p>
            <p>&nbsp;</p>
            <h5>
              2.3&nbsp; Valorization of Secondary Products from Microalgal
              Biomass
            </h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Cell walls of many microalgae are made of complex microfibrillar
              structures placed within a glutinous protein cell matrix (Yap et
              al., 2016). However, some microalgae that belong to
              Bacillariophyceae and Charophyceae family are protected by a rigid
              inorganic wall of silica or calcium carbonate (Bolton et al.,
              2016), and the growth environment significantly influences the
              thickness and microalgal cell wall compo- sition (Praveenkumar et
              al., 2015). The cell wall is disrupted to extract lipid, which is
              done either by physical or chemical pretreatment methods to
              improve amenability of cell constituents by organic solvents.
              Various physicochemical cell disruption methods experimented with
              bead milling, osmotic shock, pulsed electric field, microwave,
              ultrasound, and freezing/thawing. Various pretreatment and
              bioenergy conversion processes used for bioenergy production from
              microalgal biomass are illustrated in Fig. 2.
            </p>
            <p>
              Among diverse cell disruption methods, ultrasound treatment
              (sonication) is reported to improve the cell disruption efficiency
              of microalgae (Ramachandra et al., 2011, 2013). Microwave
              treatment was a rapid process that enabled 80% of the cell lysis
              (Abbassi et al., 2014). After cell disruption, either
              thermochemical or biological processes are carried out to derive
              secondary products like bioethanol, bio-oil, biogas, biobutanol,
              volatile fatty acids, biohydrogen, and biopolymers (Venkata Mohan
              et al., 2020). Gasification, pyrolysis, hydrogenation,
              liquefaction, and combustion are thermochemical conversion
              processes that involve applying heat energy to obtain end
              products. The energy obtained from such thermochemical processes
              is mainly gaseous forms or energy-rich biocrude that is upgraded
              to bioenergy products. Biological treatments such as anaerobic
              digestion, fermentation, and heterotrophic fermentation would
              result in biogas, bioethanol, alcohols, and liquid hydrocarbons,
              whereas physicochemical conversion using extraction and
              transesterification would lead to biodiesel (Jankowska et al.,
              2017). Possible bioenergy components from microalgal biomass from
              an energy perspective are methane, biodiesel, biocrude&mdash;
              possible refinement into gasoline and green diesel, biobutanol and
              ethanol, biohy- drogen, and bioelectricity from microalgal
              carbohydrates. Figure 3 illustrates the valorization of microalgal
              biomass into various forms of bioenergy as secondary products.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Table 1 </strong>Research institutions across the globe
              working on microalgae (diatom)
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>Species</p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Research institution</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Targeted biomolecules</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>References</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>
                        Navicula cincta, Nitzschia punctata, Amphiprora sp.,
                        Chaetoceros spp., Cyclotella sp.
                      </em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Indian Institute of Science, Bangalore</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Biodiesel and EPA</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Saranya and Ramachandra (2020)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Amphora coffeaeformis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>
                      Centre for advanced studies in botany, University of
                      Madras, Chennai
                    </p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Biofuel and essential fatty acids</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Rajaram et al. (2018)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>
                        Nitzschia paea, Gomphonema parvulum, Nitzschia
                        inconspicua, Diadesmis confervaceae, Sellaphora sp.,
                        Placoneis elginensis
                      </em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Harish Singh Gour University, Madhya Pradesh</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Diatom lipids and diatom solar panels</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Pinnularia</em> <em>sp.</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>
                      School of Chemical, Biological and Environmental
                      Engineering, Oregon State University, USA
                    </p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>
                      Solar cells, batteries and electroluminescent devices, and
                      diatom solar panels
                    </p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Jeffryes et al. (2011)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Coscinodiscus walesii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>
                      National Council of Research Institute for
                      Microelectronics and
                    </p>
                    <p>Microsystems-Department of Naples</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Diatom solar panels</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>De Stefano et al. (2007)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Synedra sp., Diatom consortium</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Noida International</p>
                    <p>University, Uttar Pradesh</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Fatty acids and triglycerides</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Li et al. (2017)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Achnanthes</em>
                      <em> sp.</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Scripps Institution of Oceanography</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Biofuel</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Hildebrand et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Halamphora coffeaformis,</em>
                    </p>
                    <p>
                      <em>Navicula cincta</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Bahia Blanca, Argentina</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Biodiesel and essential fatty acids</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Mart&iacute;n et al. (2018)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Diatom</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>The University of Colorado, Boulder, USA</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Diatom-based taxonomy and limnological studies</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Andrejic&acute; et al. (2018)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Diatom</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Rutgers University, New Brunswick, USA</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Physiological and</p>
                    <p>molecular aspects of diatoms</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Kranzler et al. (2019)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>Species</p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Research institution</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Targeted biomolecules</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>References</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Phaeodatylum tricornutum</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Shandong University, China</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Seasonal dynamics studies</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Zhang et al. (2019)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>P.</em> <em>tricornutum, Skeletonema costatum</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>University of Iceland, Reykjavik, Iceland</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Anti-cancer compounds</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Hussein and Abdullah (2020)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Thalassiosira</em>
                    </p>
                    <p>
                      <em>weisflogii,</em> <em>Cyclotella cryptica</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Istituto di Chimica Biomolecolare</p>
                    <p>(ICB)&mdash;CNR, Via Campi Flegrei 34, 80,078</p>
                    <p>Pozzuoli, NA, Italy</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Biofuel</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>D&rsquo;Ippolito et al. (2015)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Phaeodatylum tricornutum</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>Swansea University, UK</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Diatom biorefinery</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Butler et al. (2020)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Thalassiosira pseudonana</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>University of Sheffield, UK</p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Bioactive compounds</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Sethi et al. (2020)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="105">
                    <p>
                      <em>Thalassiosira weissflogi</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="135">
                    <p>
                      International Crop Research Institute for Semi-arid
                      Tropics (ICRISAT), Patancheru 502 324, Telangana State,
                      India
                    </p>
                  </td>
                  <td style={styles.cell} width="125">
                    <p>Diatom biorefinery</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Marella and Tiwari (2020)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce2.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 2 </strong>Different conversion processes for various
              energy products production from microalgae
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce3.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 3 </strong>Valorization of microalgal biomass into an
              array of bioenergy (secondary) products
            </p>
            <p>&nbsp;</p>
            <h5>2.4&nbsp; Biogas from Microalgal Biomass</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Anaerobic digestion (AD) of microalgal biomass has emerged as a
              promising tech- nology through the decomposition of organic matter
              by anaerobic bacteria into biogas. AD is a four-step process
              involving hydrolysis, acidogenesis, acetogenesis, and
              methanogenesis (Ward et al., 2008). The main components of biogas
              are methane and carbon dioxide. The biogas quality is usually
              determined by the relative amount of methane, which depends on the
              substrate and operating conditions for anaerobic fermentation
              (Sialve et al., 2009). Several studies have shown the possibility
              of using spent. The microalgal biomass constitutes appropriate
              feedstock for biogas produc- tion as it contains a high quantity
              of proteins (51&ndash;64%), followed by carbohydrates
              (6&ndash;21%) and lipids (7&ndash;16%) (Jankowska et al., 2017)
              with a yield of 0.09&ndash;0.54 L CH<sub>4</sub> g
              <sup>&minus;1</sup> (Sialve et al., 2009). However, the efficiency
              of biogas production is species- specific as complex recalcitrant
              cell wall structure and composition of some algae hinder the
              anaerobic digestion due to the inability to penetrate cell walls
              by bacteria (termed as anaerobic biodegradability). Hence, various
              pretreatment methods for disrupting cell walls include thermal,
              microwave, ultrasonic, chemical, and mechan- ical processes
              (Kwietniewska &amp; Tys, 2014). A comparison of methane yields
              with and without pretreatment techniques is given in Table 2.
            </p>
            <p>
              Techno-economic feasibility studies have demonstrated a 35% cost
              reduction in
            </p>
            <p>
              production (Harun et al., 2011), energy recovery, and improvement
              in the energy balance by integrating methane production with
              biodiesel production (Alzate et al., 2014; Francisco et al., 2010;
              Zhao et al., 2014). Energy recovery of 80% was recorded in a study
              that used <em>Isochrysis galbana </em>for integrated biodiesel and
              biogas production biorefinery approach.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Table 2 </strong>Pretreatment methods and methane
              production from different microalgae
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>Microalgae</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Pretreatment</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>Operating conditions (Temp oC, days)</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>
                      CH<sub>4</sub> production (mL g&minus;1 VS)
                    </p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Reference</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Chlorella</em> <em>vulgaris</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>35, 25</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>314 &plusmn; 18</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Zhao et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Nannochloropsis salina</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Without lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>35, 25</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>557 &plusmn; 5</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Zhao et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Phaeodactylum tricornutum</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Without lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>35, 25</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>337 &plusmn; 15</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Zhao et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Phaeodactylum tricornutum</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>After lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>339 &plusmn; 13</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Zhao et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Nannochloropsis gaditana</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Lipid extraction with ethanol</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>35, 53</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>327 &plusmn; 2</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Alzate et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Nannochloropsis gaditana</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Without lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>35, 53</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>303 &plusmn; 5</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Alzate et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Tetraselmis</em> sp<em>.</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Without lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>38, 65</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>160</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Hern&aacute;ndez et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Tetraselmis</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Supercritical</p>
                    <p>
                      CO<sub>2</sub> extraction
                    </p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>38, 65</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>236</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Hern&aacute;ndez et al. (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Scenedesmus</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>Without oil extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>ND, 32&ndash;40</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>212.3 &plusmn; 5.6</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>Ramos-Su&aacute;rez and Carreras (2014)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="91">
                    <p>
                      <em>Isochrysis galbana</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>After lipid extraction</p>
                  </td>
                  <td style={styles.cell} width="95">
                    <p>38, 30</p>
                  </td>
                  <td style={styles.cell} width="88">
                    <p>310</p>
                  </td>
                  <td style={styles.cell} width="81">
                    <p>S&aacute;nchez-Bayo et al. (2020)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <h5>2.5&nbsp; Fermentation into Bioethanol</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Microalgae have been receiving attention as a carbohydrate
              feedstock for their effective fermentation into bioethanol. After
              lipid extraction, the deoiled biomass containing starch and
              cellulose can be used for bioethanol production (Shokrkar et al.,
              2018). Simultaneous saccharification and fermentation of
              microalgal biomass using enzymes have shown higher yields of
              reducing sugars with prospects in cost-effective fermentation into
              bioethanol (Shokrkar &amp; Ebrahimi, 2018). A study on enzymatic
              hydrolysis of microalga <em>Chlorella vulgaris </em>as feedstock
              for bioethanol produc- tion resulted in a glucose yield of 90.4%
              (0.461 g/g biomass) bioethanol produc- tion (Ho et al., 2013). A
              microalgal biorefinery of microalga{" "}
              <em>Dunaliella tertiolecta </em>biomass after lipid extraction
              subjected to chemoenzymatic saccharification yielded
            </p>
            <p>0.14 g/g residual biomass (Lee et al., 2013).</p>
            <p>&nbsp;</p>
            <h5>2.6&nbsp; ABE Fermentation to Biobutanol</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              The microalgal residue with readily digestible polysaccharides
              like starch is being used as feedstocks for selective fermentation
              into higher alcohols such as biobu- tanol. For instance, green
              microalgae <em>C. vulgaris </em>is reported to accumulate starch
              in the range of 12&ndash;37% (Hirano et al., 1997; Spolaore et
              al., 2006). Microalgae can be cultivated throughout the year with
              a possibility of continuous harvesting (John et al., 2011), and
              less readily fermentable sugars such as galactose, xylose, and
              mannose are present only in minimal quantities, unlike
              lignocellulosic biomasses (Foley et al., 2011). Microalgae
              cultivation does not require arable lands and does not constitute
              a major food resource (Foley et al., 2011). Butanol has been
              sought after fuel in recent times owing to its superior
              alternative to ethanol considering (i) heating value, (ii) less
              volatile, and (iii) less corrosive, thus favourable for easy
              distri- bution and storage infrastructure. Biological production
              of biobutanol is achieved by acetone-butanol-ethanol (ABE)
              fermentation of microalgal biomass using a solven- togenic
              anaerobic bacterium belonging to the genus <em>Clostridium</em>.
              This bacterium is known for its capability to convert a wide range
              of organic carbon sources, including glucose, cellobiose,
              arabinose, galactose, xylose, and mannose by secreting numerous
              polymer degrading enzymes such as alpha-amylase, beta-amylase and
              beta glucosidase, glucoamylase, amylopullulanase, and pullulanase
              (Ezeji et al., 2007a, 2007b). Incorporating these bacterial
              strains into carbohydrate-rich feed- stocks under anaerobic
              conditions, the bacterium breaks down complex polysaccha- rides
              into butyric and acetic acid through an acidogenic process
              solventogenesis with the synthesis of acetone, ethanol, and
              butanol (Lee et al., 2008). Microalgal carbo- hydrates serve as
              feedstocks for fermentative bioethanol or biobutanol. Thus, the
              species-specific carbohydrate composition of microalgae determines
              the efficiency of ABE fermentation. The starch or carbohydrate
              contents of different microalgae are given in Table 3.
            </p>
            <p>
              The carbohydrate content of microalgae varies significantly across
              species is divided into two functional components as (i) energy
              reserves (e.g., starch, glycogen) and (ii) structural
              polysaccharides (such as cellulose). The cell wall and storage
              components of cyanophycean members are lipopolysaccharides,
              peptidoglycan, and
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Table 3 </strong>Carbohydrate content of different
              microalgae
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>Microalgae</p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>Total carbohydrates (% dry weight)</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Reference</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Nostoc </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>52.3</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Dunalliella tertiolecta</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>50.6</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Arthrospira</em>
                      <em> platensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>40.8</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Tetraselmis </em>sp. CS-362
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>26.0</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Brown et al. (1998)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Nannochloropsis</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>56.8</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Arthrospira</em>
                      <em> platensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>40.8</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="128">
                    <p>
                      <em>Scenedesmus</em> <em>obliquus</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="184">
                    <p>51.8</p>
                  </td>
                  <td style={styles.cell} width="131">
                    <p>Ho et al. (2012)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>Table 4 </strong>Microalgae feedstock for biobutanol
              production
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>Microalgae</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>Biomass treatment</p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>Fermentative bacteria</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>
                      Butanol production (g L<sup>&minus;</sup>
                      <sup>1</sup>)
                    </p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Reference</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>
                      <em>Arthrospira</em> <em>platensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>Sulfuric acid</p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>
                      <em>Clostridium acetobutylicum </em>B1787
                    </p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>9.13</p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>
                      <em>Nannochloropsis </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>Sulfuric acid</p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>
                      <em>C. acetobutylicum </em>B1787
                    </p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>10.9</p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Efremenko et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>
                      <em>Chlorella vulgaris</em>
                    </p>
                    <p>JSC-6</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>NaOH (1%),</p>
                    <p>
                      H<sub>2</sub>SO<sub>4</sub> 3%
                    </p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>
                      <em>C. acetobutylicum </em>ATCC 824
                    </p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>13.1</p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Wang et al. (2016)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>
                      <em>Chlorella</em>
                      <em> sorokiniana </em>(lipid extracted biomass)
                    </p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>
                      H<sub>2</sub>SO<sub>4</sub> (2%)
                    </p>
                    <p>+ NaOH (2%)</p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>
                      <em>C. acetobutylicum </em>ATCC 824
                    </p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>3.86</p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Cheng et al. (2015)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="99">
                    <p>Wastewater algae</p>
                  </td>
                  <td style={styles.cell} width="66">
                    <p>
                      H<sub>2</sub>SO<sub>4</sub> and enzyme treatment
                    </p>
                  </td>
                  <td style={styles.cell} width="163">
                    <p>
                      <em>C. Saccharoperbutylacetonicum</em>
                    </p>
                    <p>N1-4</p>
                  </td>
                  <td style={styles.cell} width="57">
                    <p>7.79</p>
                  </td>
                  <td style={styles.cell} width="58">
                    <p>Ellis et al. (2012)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              cyanophycean starch, respectively. Cellulose and hemicellulose are
              from the struc- tural polysaccharides, while starch/lipids include
              the storage polysaccharides in species of Chlorophyta division.
              The cell wall component is absent in the divi- sion Euglenophyta,
              and the storage product comprises Paramylum/Lipid. Cellulose,
              agar, carrageenan, and calcium carbonate form the significant
              components of the cell wall, and Floridian starch is the primary
              storage component in Rhodophyta, owing to the variations in the
              cell wall, biological treatment of microalgae requires
              pretreatment methods based on cell wall compositions. The
              pretreatment methods aid in cell wall disruptions and make the
              internal storage components available for the microbial
              consortium. Different physical, mechanical, and thermo-chemical
              pretreat- ments have been experimented with to improve the
              bioavailability of microalgal cell components to increase
              fermentation efficiency for biobutanol production are given in
              Table 4.
            </p>
            <p>
              Despite having numerous advantages, biobutanol production
              technology is still in its nascent stage, which warrants further
              investigations. The biorefinery approach of utilizing biofilm
              cultivated biomass after lipid extraction for ABE fermentation
              would have the potential of attaining economic feasibility with
              sustainable biofuel production.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h5>2.7&nbsp; Biocrude From HTL</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Hydrothermal liquefaction (HTL) entails converting wet microalgal
              biomass into liquid biocrude by subjecting the biomass to a high
              temperature (280&ndash;370 &deg;C) and pressure (10&ndash;25 MPa),
              circumventing higher energy costs in biomass drying.
            </p>
            <p>&nbsp;</p>
            <p>
              Algal concentration ranging between 5 and 20%, HTL treatment can
              be carried out with just &lt; 5% of the energy costs required for
              drying (Xu et al., 2011), and synthesized biocrude possess an
              energy value close to fossil petroleum (Jena &amp; Das, 2011),
              which can be fractionated into different energy products.
              Hydrothermal degradation of microalgal biochemical constituents
              (carbohydrates, lipids, proteins) provides biocrude, a dark,
              viscous, energy-rich liquid (L&oacute;pez Barreiro et al., 2013).
              Research on HTL has considerably increased, which is evident from
              publications related to HTL of <em>S. platensis</em>,{" "}
              <em>Botryococcus barunii</em>, <em>Desmodesmus </em>sp.,{" "}
              <em>C. vulgaris</em>, and <em>Nannochloropsis </em>sp. (Biller
              &amp; Ross, 2011; Brown et al., 2010). Typical elemental
              composition analysis of biocrude produced from Desmodesmus sp.
              with operating conditions of 375 &deg;C for 5 min reaction time
              yielded 74.5% C, 8.6% H, 10.5% O, and 6.3% N with a higher heating
              value (HHV) of 35.4 MJ/kg. In comparison with other
              thermo-chemical conversion technologies of pyrolysis and
              gasification, HTL possess prominent characteristics such as (i)
              higher oil yield with the complete conversion of whole algal
              biomass into biocrude and other chemicals, (ii) elimination of
              drying process, (iii) higher lipid content (not an important
              criterion in HTL), (iv) enhanced HTL efficiency due to the
              enthalpy of phase change of water at higher pressure, (v)
              additional rectification or extraction is not required, and (vi)
              principal product is self- regulated (Tian et al., 2014). The
              current approach of biofuel conversion of algae to biodiesel needs
              to be economically viable. However, integration of HTL technology
              with current algae conversion technology would lead to sustainable
              utilization of algae residue after extracting lipids for biocrude
              production. Various experimental conditions of the
              microalgae-based HTL process, and its corresponding biocrude
              yields are given in Table 5.
              <br />
              <br />
            </p>
            <p>
              <strong>Table 5 </strong>HTL experimental conditions and biocrude
              yield reported on different microalgae
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>Microalgae</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>Temp (oC), holding time (min)</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>Catalyst used</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>Biocrude yield (%)</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Reference</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Botryococcus braunii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>300, 60</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>
                      Na<sub>2</sub>CO<sub>3</sub> (5%)
                    </p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>64</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Dote et al. (1994)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Desmodesmus</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>375, 5</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>No catalyst</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>49</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Garcia Alba et al. (2012)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Chlorella</em> <em>vulgaris</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>350, 60</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>Pt/Al2O3 (1 mol L&minus;1)</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>38.9</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Biller and Ross (2011)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Nannochloropsis </em>
                      <em>sp.</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>350, 60</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>Pd/C</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>~ 57</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Brown et al. (2010)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Spirulina</em> <em>platensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>350, 60</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>No catalyst</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>39.9</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Jena and Das (2011)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Nannochloropsis occulata</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>350, 60</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>No catalyst</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>34.3</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Biller and Ross (2011)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="97">
                    <p>
                      <em>Chlorella pyrenoidosa</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>280, 120</p>
                  </td>
                  <td style={styles.cell} width="116">
                    <p>No catalyst</p>
                  </td>
                  <td style={styles.cell} width="84">
                    <p>39.4</p>
                  </td>
                  <td style={styles.cell} width="71">
                    <p>Cheng et al. (2017)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <h5>2.8&nbsp; Algae as Feedstock for Biopolymers</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Bio-based polymers are gaining significant attention over
              petroleum-based poly- mers due to their biodegradability and
              benign environmental characteristics (Garrison et al., 2016). A
              variety of bio-based raw materials such as resins and lignin
              derivatives, polysaccharides sourced from various feedstocks,
              proteins, and vegetable oils have been investigated for their
              suitability in bio-polymer production (Gandini, 2008). The current
              primary production of bioplastics is from terrestrial plant-based
              starch, and poly-lactic acid (PLA) polymers derived from corn and
              sugar beets (Sreedevi et al., 2014) competes with arable lands.
              Several bacterial strains capable of producing a range of
              exopolysaccharides and polyhydroxyalkanoates (PHA) have been
              commercially used as precursors for bioplastics (Rehm, 2010).
              However, with the enhanced plastic demand, and conventional
              plastics are posing significant threats to the environment,
              especially to marine ecosystems (Rahman &amp; Miller, 2017).
              Microalgae secrete extracellular polymeric substances (EPS)
              comprising polysac- charides, proteins, lipids, and uronic and
              nucleic acids (Venkata Mohan et al., 2020). These EPS are being
              converted into bioplastics (polyhydroxyalkanoates (PHA), Poly-
              lactic acid (PLA), or thermoplastic starch (TPS) through the
              thermochemical conver- sion process by using glycerol as a
              co-substrate (Jerez et al., 2007). Biological routes of bioplastic
              production from microalgae are realized either through direct
              utilization and conversion of microalgal biomass or by utilizing
              the aqueous phase (hydrolysate) spent biomass as a source of
              nutrient for growing recombinant <em>Escherichia coli </em>which
              produces the bioplastic polyhydroxy butyrate (PHB) (Rahman et al.,
              2015).
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h5>2.9&nbsp; Bioelectricity Through Microbial Fuel Cells</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Microalgae-microbial fuel cells (mMFC) convert solar energy into
              electricity through a bioelectrochemical process through a
              combination of live and dead microalgae in respective cathodic and
              anodic chambers (Lee et al., 2015). In microbial fuel cell (MFC)
              technology, live microalgae are placed in a cathode chamber
              (photore- actor) that acts as a biocathode. This biocathode
              produces O<sub>2</sub> due to photosynthesis and acts as an
              electron acceptor from the external circuit (Wang et al., 2010).
              The anode chamber consisting of organics undergo digestion by
              releasing CO<sub>2</sub> and excess protons to the cathode chamber
              and also acts as an electron donor resulting in the generation of
              electricity (Juang et al., 2012). Live green algae growing in
              cathode chamber and used dead microalgal biomass as the substrate
              for anodic biofilm have been utilized to understand its
              feasibility for bioelectricity production. For example, microalga{" "}
              <em>C. vulgaris </em>grown in a cathodic chamber was found to
              photosynthesize increase the dissolved oxygen levels of the
              chamber. This increase in DO had a posi- tive correlation with
              voltage output (Juang et al., 2012). The influence of light
              intensity on the cathodic resistance was investigated (Wu et al.,
              2014) and found that the light intensity was found to increase the
              rate of photosynthesis of <em>Desmodesmus </em>sp.,resulting in
              higher O<sub>2</sub> levels, which enhanced the mMFC&rsquo;s
              cathodic resistance to induce bioelectricity. Though mMFC is at
              the nascent stages of research, substantial improvements have been
              made on microalgae coupled microbial fuel cell processes in recent
              years. However, further research is required to integrate this
              technology in a biorefinery approach to attain a circular
              bioeconomy.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h5>2.10&nbsp; Commercial Applications of Microalgal Biomass</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Microalgae possess characteristics that are favourable for diverse
              commercial appli- cations. The most important commercial
              application is in food nutrition as a protein source such as{" "}
              <em>Chlorella</em>, <em>Spirulina, </em>and <em>Dunaliella </em>
              (Javed et al., 2019). Studies have shown that microalgal biomass
              pellets have shown curing effects of gastroin- testinal ailments
              through enhancement of intestinal Lactobacillus and treatment of
              renal failure (Yamaguchi, 1996). Green microalgae have potential
              applications in cosmetic industries, especially as sun and hair
              care products. For instance, <em>Chlorella </em>and{" "}
              <em>Arthrospira </em>sp. are being used as skincare essentials in
              the cosmetic industry as anti-irritants, anti-wrinkle agents, and
              anti-ageing creams. Algae like <em>Chlorella</em>,{" "}
              <em>Scenedesmus</em>, and <em>Spirulina </em>have been explored
              for their use as animal feed, espe- cially as shrimp and
              aquaculture feed (Chuntapa et al., 2003). Microalgae are used as
              nutraceutical raw material for extraction of polyunsaturated fatty
              acid (PUFA), which is being used as an additive in infant milk and
              as feed to rear farm chicken enriches the amount of Omega-3 fatty
              acids in eggs (Pulz &amp; Gross, 2004). Figure 4 illustrates the
              industrially relevant bioproducts possible from microalgae. Table
              6 lists the price/ton for different microalgal species and
              estimated production per year.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce4.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 4 </strong>Different industrially relevant
              bioproducts extractable from microalgae
              <br />
              <br />
            </p>
            <p>
              <strong>Table 6 </strong>Estimated price per ton of microalgal
              biomass (Brennan &amp; Owende, 2010; Tredici et al., 2016)
            </p>
            <p>&nbsp;</p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>Microalgae species</p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>Estimated production in kilo tons per year</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>Price (millions)/ton INR</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>
                      <em>Spirulina</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>3</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>2.99</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>
                      <em>Chlorella</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>2</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>2.99</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>
                      <em>Dunaliella</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>1.2</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>98.3</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>
                      <em>Crypthecodinium cohnii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>0.24</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>3.5 (billion)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="94">
                    <p>
                      <em>Tetraselmis</em>
                      <em> suceica</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="97">
                    <p>0.036</p>
                  </td>
                  <td style={styles.cell} width="104">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <h4>3&nbsp; Algal Refinery with Microalgal Bioreactor</h4>

            <p>
              The microalgal bioreactor was implemented using granite stones as
              substrates for microalgal cultivation in an abandoned{" "}
              <em>gazani </em>(flood plain where earlier salt tolerant paddy was
              cultivated) land present in the coastal regions of Karnataka. The
              various processes involved in the installation of the microalgal
              bioreactor are illustrated in Fig. 5.
            </p>
            <p>
              The land preparation techniques required for setting up a
              microalgal biore- actor include: (i) liming, (ii) pitching, (iii)
              mud bank formation, and (iv) watergate installation. Land
              preparation is done using lime (in the form of crushed dolomite
              (CaMg(CO<sub>3</sub>)<sub>2</sub>) or crushed limestone (CaCO
              <sub>3</sub>). Pitching is a process of levelling the land, which
              requires five persons working on the activity for 3-human days (7
              h a day) in one-hectare land. A workforce of 2 persons for the
              1-human day (7 h) is required for the liming activity. The granite
              stones are to be placed at an elevated position to avoid sediment
              interferences during microalgal biofilm formation. A combination
              of manual labour and machinery (JCB) is used for bioreactor
              installation.
            </p>
            <p>
              Microalgae cultivated using substrate-based bioreactor has most
              diatoms in its species composition in the study region. Natural
              self-seeding of microalgae on the substrate was assumed with no
              addition of any external inoculum. A hybrid system involving
              harvesting manually and scrubbing using mechanized scrubbers at
              the end of a 5&ndash;7 days growth period was considered for the
              study. The drying of harvested algal biomass was carried out
              through direct solar drying in the first scenario while drying
              using a filter press, followed by solar drying in the second
              scenario. Transes- terification of microalgal oil was carried out
              through direct transesterification of dried biomass using acid
              (dilute mineral acid (2% H<sub>2</sub>SO<sub>4</sub>) and
              biocatalyst (lipase). FAME conversion efficiencies of 83% for acid
              catalyst and 87% for biocatalyst was consid- ered (based on
              conversion efficiencies obtained in prototype lab-scale
              experiments). Bioproducts from algal refineries include biodiesel,
              glycerol, biogas, algal meal, and fertilizer.
              Acid/biocatalyst-based transesterification of algal biomass
              results in biodiesel as the primary energy product and crude
              glycerol as the reaction byproduct. The crude glycerol after
              refining has diverse applications in the pharmaceutical and
              cosmetic industries. The spent algal biomass, when subjected to
              anaerobic digestion,
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce5.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 5 </strong>Processes in biodiesel production with
              material inputs
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>
              results in biogas. The solid residue left over after biogas
              production was considered a biofertilizer source with scope for
              direct application as a source of nitrogen in agricultural fields.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h5>3.1&nbsp; Techno-Economic Analysis</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              Techno-economic analyses were carried out for a bioreactor in a
              one-hectare plot in the flood plains. Considering (i) different
              nutrients input, (ii) acid and biocatalysts (lipase), and (iii)
              varied FAME conversion efficiencies. Discounted cash flow model
              was used to assess the financial feasibility of the proposed
              microalgal cultivation system. The model considered 60% of the
              capital investments as project financing loans from the National
              Bank for Agriculture and Rural Development (NABARD) with an annual
              loan repayment determined by a 4.5% interest rate for a loan
              tenure of 5 years and the remaining 40% of farmer&rsquo;s
              investment share. The capital and operating (fixed and variable)
              costs were determined by considering the material and energy
              inputs at each stage (Table 7). The capital costs were estimated
              to evaluate the different processes considered with details of
              equipment, transportation costs, and raw material requirement
              incurred under each unit operation. Under capital costs, inventory
              of materials used for constructing bioreactor (granite stones for
              substrates, etc.) in a land area of 9000 m<sup>2</sup> (0.9 ha).
              The capital cost was fixed based on the actual market prices of
              the bioreactor materials and workforce requirements at the
              installation time. The cost of fermenters for biocatalyst
              production was included as an additional capital cost (in the
              biocatalyst scenario).
            </p>
            <p>
              Operating costs include the following contributions: energy,
              materials, land lease, maintenance, and loan repayments. For
              operating cost estimation, the processes involved in algal
              biodiesel production were categorized into five different phases:
            </p>
            <p>
              (i) feedstock growth, (ii) biomass harvest, (iii) pretreatment,
              (iv) transesterification,
            </p>
            <p>
              <strong>Table 7 </strong>Methods used for techno-economic analysis
            </p>
            <p>Methods used for calculating techno-economic analysis</p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>S. No.</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Parameter</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>Calculation methods</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="2" width="260">
                    <p>Facility lifetime</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>30 years</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Capital</em> <em>cost</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>1.a</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Bioreactor material/fermenter procurement</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>Actual prices from manufacturers</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>1.b</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Pitching, mud bank, and watergate installation cost</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>
                      Through personal interviews and interaction with
                      landowners and shrimp farmers
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>1.c</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Labour cost for land preparation</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>
                      Fixed as per the minimum wages act after confirming the
                      same with the current scenario in the study region
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Operating</em>
              <em> cost</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Fixed operating cost</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>2.a</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Gazani land lease value</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>Fixed as per current lease trend in the study region</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>2.b</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Labour cost for harvesting</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>Same as 1.c</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>2.c</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Loan repayment cost</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>
                      Calculated by considering 4.5% interest rates on principal
                      for a loan tenure of 5 years
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Variable</em> <em>costs</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>2.d</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>Cost of lime fertilizer and solvents</p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>Actual prices of chemicals, fertilizers, and solvents</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="46">
                    <p>2.e</p>
                  </td>
                  <td style={styles.cell} width="214">
                    <p>
                      Biodiesel production and other downstream processing costs
                    </p>
                  </td>
                  <td style={styles.cell} width="182">
                    <p>
                      Fixed as per Karnataka electricity regulation
                      commission&rsquo;s standard power tariffs for industrial
                      uses
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              and (v) refining biodiesel. The system boundaries were based on
              land preparation (pitching, liming, making mud banks, and
              watergate installation) until biodiesel refining. Both the energy
              expended and the material inputs were considered with associated
              costs for TE analysis. Under fixed operating cost, gazani land
              lease value (<em>C</em>
              <sub>LV</sub>), loan repayment (<em>C</em>
              <sub>LR</sub>), and workforce requirement for manual harvesting (
              <em>C</em>
              <sub>ML</sub>) at the end of every cycle (considering 5&ndash;7
              days cycling time) for a total of 32 cycles (excluding monsoon and
              initial colonization period). In variable costs, the costs of
              chemicals (lime, fertilizers) and solvents required on an annual
              basis to run the production facility were estimated, and the
              charges were fixed based on the market prices of the respective
              chemicals. The costs incurred due to the energy spent in each of
              the downstream processes were calculated by estimating the energy
              required to perform each unit operation and converting the energy
              into costs (<em>C</em>
              <sub>EC</sub>) by multiplying the energy spent (kWh) with its
              standard power tariffs fixed as per the Karnataka electricity
              regulatory commission. Biodiesel production cost (INR/kg), payback
              period (years), return on investment, and annual profit
              (INR/ha/yr.) was calculated using Eqs. 1&ndash;4, respectively,
              assuming a facility lifespan of 30 years.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/ce1.png" alt="" />
              ........(1){" "}
            </p>

            <p>where</p>
            <p>&nbsp;</p>
            <p>
              Biodiesel cost = Total operating cost<em>(C</em>
              <sub>TOC</sub>
              <em>)(</em>INR<em>)</em>
            </p>
            <p>
              Biodiesel production volume<em>(L</em>
              <em>)</em>
            </p>

            <p>
              <em>C</em>TOC = <em>C</em>FOC + <em>C</em>VOC; <em>C</em>FOC ={" "}
              <em>C</em>LV + <em>C</em>LR + <em>C</em>ML and <em>C</em>VOC ={" "}
              <em>C</em>EC
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/ce2.png" alt="" />
              ........(2){" "}
            </p>

            <p>where</p>
            <p>&nbsp;</p>

            <p>
              Payback period = 1 +{" "}
              <em>
                n<sub>y</sub>{" "}
              </em>
              &minus; <em>p</em>
            </p>

            <p>
              <em>
                n<sub>y</sub>{" "}
              </em>
              = The year at which the last negative cumulative cash flow occurs
            </p>
            <p>
              <em>n </em>= The value of cash flow at the year{" "}
              <em>
                n<sub>y</sub>
              </em>
            </p>
            <p>
              <em>p </em>= Cumulative value at first positive cash flow
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/ce3.png" alt="" />
              ........(3){" "}
            </p>

            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              Profit = Revenue &minus; cost........ (4)
            </p>
            <p>&nbsp;</p>
            <p>
              The detailed cost breakup on fixed capital investments and
              operating costs required for setting up a substrate-based
              microalgal cultivation setup is summarized in Tables 8 and 9,
              respectively. Capital investment for all three scenarios was the
              same (| 67,500 INR/ha) for bioreactor (substrate&ndash;granite
              stone: procurement and installation and | 18,500 INR/ha for land
              preparation). Earlier studies considered land costs as a capital
              investment as land is purchased for setting up bioreactor
              facilities. For instance, a land cost of $7800/ha (Davis et al.,
              2011), $138,000/ha (Norsker et al., 2011),
            </p>
            <p>
              $1200/ha (Xin et al., 2016) was considered as capital cost.
              However, the land lease value (| 20,000/ha/yr.) of the abandoned
              flood plains was considered under operating costs in this study.
            </p>
            <p>
              Other operating costs considered in the present study include
              manpower labour charges (| 28,800 INR/ha/yr.), transesterification
              (chemicals + energy) costs, and yearly loan repayment costs. The
              loan repayment cost was estimated as | 22,368 INR/yr. for
              scenarios 1 and 2, considering 4% interest. In contrast, for
              scenario 3, the loan repayment cost was higher (| 50,040 INR/yr.),
              which was influenced by the fertilizer costs in the acid catalyst
              sub-scenario. In contrast, in the case of the biocatalyst
              sub-scenario, | 67,116 INR/yr was estimated due to the additional
              costs required for fermenter procurement. The material input for
              acid and biocatalyst sub- scenarios was different among the three
              varying nutrient input scenarios as the nature and amount of
              chemicals, solvents, and reaction conditions were different for
              trans- esterification using acid and biocatalyst. The assumption
              on biodiesel yields achiev- able using acid and enzyme (bio)
              catalysts were also different (based on the FAME productivity).
              Thus, the significant scenarios (Scenario 1&ndash;3) were
              explained with two different sub-scenarios of acid and enzyme
              (lipase) as catalysts for transesterification. The material and
              energy outputs considered for analysis were (i) algal biomass
              (AFDW) (kg/ha/yr), (ii) Biodiesel from the harvested biomass
              (kg/ha/yr), (iii) the quantity of crude glycerol obtained as a
              byproduct during the biodiesel process, and (iv) biogas production
              from spent biomass (m<sup>3</sup>). Conventionally, biodiesel
              production produces 10% crude glycerol (v/v) as the main byproduct
              (Yang et al., 2012). Hence, 10% of the total biodiesel yield
              possible per ha area for a period of one year was taken as the
              crude glycerol yield. After lipid extraction, the biogas
              production potential of the spent algal residue was about 0.272 m
              <sup>3</sup> of biogas per kg of spent algal biomass used (Harun
              et al., 2011). Revenue estimation from microalgal cultivation
              setup includes byproducts from transesterification (crude
              glycerol) and other value-added products (biogas and spent biogas
              leachate as algal meal fertilizer) be generated out of the spent
              microalgal biomass rich in protein and polysaccharides. Estimates
              revealed that for assumed biomass productivity of 6.7, 15.3, and
              28.8 tons/ha/yr under different nutrient input scenarios, acid
              catalyst-based transesterification could yield a biodiesel
              quantity of 1499.2, 3407.2, and 6388.6 kg (assuming 83% FAME
              conversion efficiency).
            </p>
            <p>
              In contrast, for the biocatalyst scenario, a higher biodiesel
              yield of 1571.4, 3571.5, and 6696.6 kg is possible with an assumed
              87% effective conversion of microalgal oil into FAME (biodiesel).
              FAME conversion efficiencies were based on the experimental
              results of using a different catalyst (Saranya &amp; Ramachandra,
              2020). To estimate the revenue possible from spent algal
              fertilizer, one-fourth of the spent microalgal biomass remained
              after biodiesel extraction and biogas production. Profit
              evaluation indicates that ~5 times more profit in scenario three
              than scenario one while using an acid catalyst and ~6 times more
              profit in biocatalyst scenario, which could be attributed to the
              higher FAME conversion efficiencies possible from biocatalyst. In
              addition, biocatalyst reduces the problem of environmental
              pollution otherwise posed by the acid catalyst. Return on
              investment is the percentage of initial investment that can be
              recovered annually as profit, and the payback period is the time
              required to retrieve investments. The return on investment (ROI)
              varied between 18.4
            </p>
            <p>
              <strong>Table 8 </strong>Detailed cost budgeting for different
              biomass productivity scenarios using acid catalyst
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="218">
                    <p>Input costs</p>
                  </td>
                  <td style={styles.cell} colspan="3" width="224">
                    <p>Different scenarios</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75">
                    <p>Scenario 1</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>Scenario 2</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>Scenario 3</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Fixed capital costs</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>Value (INR)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>Value (INR)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>Value (INR)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Gravel stones procurement</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 67,500</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 67,500</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 67,500</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Pitching, mud bank formation, laterite stone purchase,
                      liming, and water gate installation
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 18,500</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 18,500</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 18,500</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Operational</em> <em>costs</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Gazani land lease value (per ha)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 20,000</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 20,000</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 20,000</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Fertilizer input cost (kg/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>&ndash;</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>&ndash;</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 167,530</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Harvesting (manual) yearly manpower requirement (INR/yr.)
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 28,800</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 28,800</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 28,800</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass drying (shade drying)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>NA</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>NA</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>NA</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Transesterification (material + energy) costs</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 9953</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 28,601</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 51,234</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biodiesel purification cost</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 1224</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 2734</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 5126</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Loan repayment</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 22,368</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 22,368</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 50,040</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Material</em> <em>and</em>
              <em> Energy Output</em>:
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass obtained per cycle (kg)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>211</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>480</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>900</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      No. of cycles harvesting can be made (excluding monsoon)
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>32 cycles</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>32 cycles</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>32 cycles</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass yield per year (kg/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>6758.4</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>15,360</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>28,800</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Biodiesel production possible (kg) from harvested biomass
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>1499.2</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>3407.2</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>6388.6</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Quantity of crude glycerol (byproduct) (L/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>150.3</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>341.7</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>640.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Biogas production (m<sup>3</sup>)
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>1768</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>4019</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>7536</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <em>Revenue estimation</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from biodiesel production (INR)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 89,863</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 204,233</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 382,937</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from crude glycerol</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 3757.5</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 8543</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 16,020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from biogas production using spent biomass</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 16,230</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 36,896</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 69,180</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Revenue from spent algal residue as fertilizer
                      (INR/ha/yr.)
                    </p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 14,643</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 33,280</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 62,400</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Total revenue (INR/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 124,493</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 282,951</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 530,537</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Payback period</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>6.97</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>0.98</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>2.98</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Return on investment (%)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>25.0</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>95.7</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>50.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biodiesel production cost (INR/kg of biodiesel)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 54.93</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 30.08</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 50.52</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Profit (INR/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 42,148</p>
                  </td>
                  <td style={styles.cell} width="75">
                    <p>| 180,449</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 207,807</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>Table 9&nbsp;</strong>Detailed cost budgeting for
              different biomass productivity scenarios using biocatalyst
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="218">
                    <p>Input costs</p>
                  </td>
                  <td style={styles.cell} colspan="3" width="225">
                    <p>Different scenarios</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="74">
                    <p>Scenario 1</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Scenario 2</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>Scenario 3</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Fixed capital costs</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>Value (INR)</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>Value (INR)</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>Value (INR)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Fermenter for biocatalyst production</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 45,000</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 45,000</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 45,000</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Gravel stones procurement</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 67,500</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 67,500</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 67,500</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Pitching, mud bank formation, laterite stone purchase,
                      liming, and water gate installation
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 18,500</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 18,500</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 18,500</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <em>Operational</em> <em>costs</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Gazani land lease value (per ha)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 20,000</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 20,000</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 20,000</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Fertilizer input cost (kg/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>&ndash;</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>&ndash;</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 167,530</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Harvesting (manual) yearly manpower requirement (INR/yr.)
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 28,800</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 28,800</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 28,800</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass drying (shade drying)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>NA</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>NA</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>NA</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Transesterification (material + energy) costs</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 9953</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 28,601</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 51,234</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biodiesel purification cost</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 1224</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 2734</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 5126</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Loan repayment</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 33,552</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 33,552</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 67,116</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <em>Material</em> <em>and</em>
              <em> energy output</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass obtained per cycle (kg)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>211</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>480</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>900</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      No. of cycles harvesting can be made (excluding monsoon)
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>32 cycles</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>32 cycles</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>32 cycles</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biomass yield per year (kg/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>6758</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>15,360</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>28,800</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Biodiesel production possible (kg) from harvested biomass
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>1571.4</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>3571.5</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>6696.6</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Quantity of crude glycerol (byproduct) (L/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>150.3</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>341.7</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>640.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Biogas production (m<sup>3</sup>)
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>1768</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>4019</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>7536</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <em>Revenue estimation</em>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from biodiesel production (INR)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 94,195</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 214,078</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 401,397</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from crude glycerol</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 3757.5</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 8543</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 16,020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>
                      Revenue from biogas production using spent biomass (INR)
                    </p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 16,230</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 36,896</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 69,180</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Revenue from spent algal residue as fertilizer (INR)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 14,643</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 33,280</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 62,400</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Total revenue (INR/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 128,825</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 292,797</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 548,996</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Payback period (years)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>17.67</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>1.27</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>2.96</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Return on investment (%)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>18.4</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>84.8</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>51.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Biodiesel production cost (INR/kg of biodiesel)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 59.52</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 31.83</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 50.74</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="218">
                    <p>Profit (INR/ha/yr.)</p>
                  </td>
                  <td style={styles.cell} width="74">
                    <p>| 35,296</p>
                  </td>
                  <td style={styles.cell} width="77">
                    <p>| 179,110.48</p>
                  </td>
                  <td style={styles.cell} width="73">
                    <p>| 209,190</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              and 95.7% for the scenarios considered, with higher ROI (95.7%)
              was estimated for scenario 2 (wastewater input&ndash;acid
              catalyst), representing a possible favourable higher return on the
              investments made. The payback period for scenario 1 was the
              highest for biocatalyst (17 years) due to the projected less
              annual biomass productivity with estimated higher capital
              investment. However, the payback period for scenario 2 and
              scenario 3 was 1.27 and 2.96 years, respectively, showing the
              financial viability of the proposed algal reactor with biodiesel
              production. An earlier study that assessed the techno-economic
              viability of biodiesel biorefinery had demonstrated an ROI that
              varied between 18.21 and 23.12% and a payback period of
              4.3&ndash;5.5 years for different process scenarios considered
              (Vlysidis et al., 2011). The most favourable and prof- itable
              among the three considered scenarios was found to be microalgae
              cultivation using aquaculture wastewater, especially because of
              its zero associated input value as a nutrient with the wastewater
              remediation benefits.
            </p>
            <p>
              The unit production cost of biodiesel for scenarios 1&ndash;3
              while using acid catalyst varied between | 30.08 and 54.93 INR/kg
              of biodiesel. The cost of production for biocatalyst-based
              biodiesel production ranged between | 31.83 and 59.52 INR/kg. The
              biodiesel production cost per kg of biodiesel for scenario 2
              (wastewater input) was found to be the lowest (30.1&ndash;31.8
              INR/kg biodiesel) while using both acid and biocatalyst of all the
              scenarios (Tables 8and 9), thus showing scope for optimal biomass
              productivity while incurring lesser material/energy costs with
              remediation benefits and lower GHG emissions and maximum profit. A
              mass balance of algal refinery byproducts of microalgal biomass
              was carried out by assuming a 100 kg dry algal biomass (Fig. 6).
              Considering a lipid content ranging between 18 and 26%, a
              biodiesel yield of 14.94&ndash;22.62 kg is possible when the
              biomass is subjected to direct transesterification. Crude glycerol
              of 1.49&ndash;2.26 kg is also produced as a byproduct during
              transesterification, which is estimated as 10% of the biodiesel
              (Rodrigues et al., 2017). The raw biogas obtained can be
              purified/upgraded by passing on toa CO<sub>2</sub> stripper
              absorption column or directly used for domestic cooking/heating
              applications. A 10% loss in biomass was assumed during the direct
              transesterification of microalgal biomass into biodiesel. The
              slurry left out after biogas production (~55&ndash;70 kg) can be
              used as an organic biofertilizer in agricultural fields.
            </p>
            <p>
              Thus, a biorefinery-based microalgal bioreactor is proposed, which
              utilizes microalgal biomass to produce two different forms of
              bioenergy, such as biodiesel and biogas, in addition to the
              value-added products such as glycerol and biofer- tilizer.
              Deployment of such substrate-based microalgal bioreactor in the
              brackish water flood plains (that are left abandoned) along the
              coastal regions of Karnataka would provide a livelihood for the
              coastal population at a decentralized level through bioenergy
              production for their localized usage along with potential scope
              for GHG emission reduction through CO<sub>2</sub> sequestration.
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce6.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 6 </strong>Schematics of mass balance of microalgal
              bioreactor from a biorefinery perspective
            </p>
            <p>&nbsp;</p>
            <h5>3.2&nbsp; Circular Economy in Biorefinery</h5>
            <p>
              <strong>
                <em>&nbsp;</em>
              </strong>
            </p>
            <p>
              One of the challenges in the advancement of the economic viability
              of microalgal biofuel is reducing the cost incurred in harvesting,
              drying, and lipid extraction processes. Biofilm-based algal
              cultivation helps in addressing the issues relating to harvesting,
              apart from addressing light limitation issues, while enhancing CO
              <sub>2</sub> mass transfer (Gross et al., 2015). Thus, integrating
              biofilm-based algal cultivation into a biorefinery would bring in
              multiple benefits (products) useful for diverse industrial
              applications apart from providing economic feasibility. As
              microalgae are rich in carbohydrates, they could be converted into
              a range of bioenergy compo- nents like biogas, biohydrogen, and
              liquid biofuels through different biological processes. Algal
              biomass, when subjected to anaerobic digestion, will result in
              biogas. The carbohydrates from algal biomass subjected to
              fermentation give butanol and ethanol. Acetone-Butanol-Ethanol
              (ABE) fermentation is an anaerobic fermen- tation process carried
              out using a gram-negative bacterium called{" "}
              <em>Clostridium beijer- inckii</em>. Butanol is gaining
              considerable attention due to its superior fuel value and better
              storage characteristics. Another way of converting wet algal
              biomass produced is by hydrothermal liquefaction (HTL). HTL
              enables direct conversion of wet algal biomass into biocrude with
              medium temperature and pressure conditions varying between
              350&ndash;550 &deg;C and 20&ndash;25 MPa (Elliott et al., 2013).
              At specified operating conditions, the liquid water present in the
              algal biomass maintained at sub-critical levels act as a catalyst
              for biocrude production. HTL pathway to produce biocrude research
              is now in progress across the globe (Dote et al., 1994; Stephens
              et al., 2010; Wiley et al., 2013). This HTL process greatly
              reduces the energy spent on biomass harvesting and drying.
              Microalgal biomass rich in pigments like carotenoids is valuable
              as feedstock for bioactive/value-added product synthesis. The
              harvested
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ce7.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Fig. 7 </strong>Sustainable biorefinery for utilizing
              microalgal biomass
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>
              biomass subjected to oil extraction and subsequent
              transesterification would result in biodiesel. A detailed
              illustration of various ways of utilizing algal biomass grown
              using a low-cost sustainable algal production system is shown in
              Fig. 7.
            </p>
            <p>
              The current research focus is towards zero-waste biorefinery based
              on reducing, reuse, and recycling waste. Zero waste biorefineries
              eliminate the use of external energy or material inputs by
              understanding the material&rsquo;s use-value, efficient use of
              materials, and a planned framework on technologies for
              establishing a sustain- able zero-waste biorefinery (Venkata Mohan
              et al., 2020). Microalgal cultivation in wastewater helps in the
              cost-effective treatment of wastewater with resource recovery.
              Thus, the biorefinery framework by using microalgae as feedstock
              provides a promising sustainable path with the circular
              bioeconomy.
            </p>
            <p>
              <br />
              <br />
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
